import ISourceData from './ISourceData';

export default {
    duplicate(sourceData: ISourceData | undefined): ISourceData {
        const result: ISourceData = {};

        if (sourceData) {
            const keys = Object.keys(sourceData);
            for (const key of keys) {
                result[key] = sourceData[key];
            }
        }
        return result;
    },
};
